import { Injectable } from "@angular/core";
import { URLS } from '../../../config/api.config';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { CommonService } from "../../helpers/common.service";

@Injectable()
export class TotalClientService {

    private clientDetailList = URLS.clientDetailList;
	private fetchClientDashboardDetails = URLS.fetchClientDashboardDetails;
	private getClientswithactiveHoldings = URLS.getClientswithactiveHoldings;


	constructor(private httpClient: HttpClient,
		private nativeHttp: HTTP,
		private commonService: CommonService) {
		
	}
private sendReqToServer(params: any, config: any, reqHead: any): Observable<{}> {
		return this.httpClient.post('/api/secure/brokerage-service', {
			params,
			config,
			reqHead
		});
	}
	public clientList(cookievalue: any, data: any): Observable<{}> {
		let params: any = {
			head: {
				RequestCode: "CVUpdateLead01",
				Key: "",
				AppName: this.clientDetailList.appName,
				AppVer: "1.0.4.0",
				OsName: "Android",
			}
        }
        params['body']= data;
		let reqHead: any = {
			'Ocp-Apim-Subscription-Key': "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			reqHead['token'] = cookievalue;
		}
		const config = {
			url: this.clientDetailList.url,
			Key: 'Verify_Guest_And_ExtendedApi',
			subKey: 'AAA_OCP'
		}
		if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('json');
		return this.sendReqToServer(params, config, reqHead);

    }

	public fetchClientDetails(cookievalue: any, data: any, env:any): Observable<{}> {
		
		let params: any = {
			head: {
				RequestCode: "FetchClientDashBoardDetails",
				Key: "",
				AppName: this.fetchClientDashboardDetails.appName,
				AppVer: "1.0.4.0",
				OsName: "Android",
				userType: this.commonService.get('userType')
			}
        }
        params['body']= data;
		
		let reqHead: any = {
			'Ocp-Apim-Subscription-Key': "",
			'appID': this.commonService.get('appID') || ''
		};
		if (cookievalue) {
			reqHead['token'] = cookievalue;
		}
		const config = {
			url: this.fetchClientDashboardDetails.url,
			Key: 'VerifyRequestApi',
			subKey: 'AAA_OCP'
		}
		if (this.commonService.isApp()) this.nativeHttp.setDataSerializer('json');
		return this.sendReqToServer(params, config, reqHead);
    }

	getClientDetails(passObj:any): Observable<any> {
		// console.log('getClientDetails',passObj)
		const config = {
			url: this.getClientswithactiveHoldings.url,
		}
		const params = {
			body: {
				LoginID: this.commonService.get('userId1')?.toLowerCase(),
				"Type": this.commonService.get('toggleSwitch') === "Self" ? "Individual" : "Hierarchy",
	 			"PageNo": passObj.PageNo,
				"SortBy": passObj.SortBy,
				"SortOrder": passObj.SortOrder,
				"SearchBy": passObj.Search,
				"SearchText": passObj.SearchText,
			}
		}
		const reqHead = {
			token: this.commonService.get('jwt_token'),
		}

		return this.httpClient.post('/api/secure/mf-data-service', { config, params, reqHead });
	}

}